import { gql } from '@apollo/client';

const SUBMIT_CHECK_POINT_DATA = gql`
  mutation SubmitCheckPointData($data: CheckPointInput!) {
    submitCheckPoint(data: $data)
  }
`;

export default SUBMIT_CHECK_POINT_DATA;
